import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { AtgOrderConfirmationOverviewComponent } from './atg-order-confirmation-overview/atg-order-confirmation-overview.component';
import { AtgOrderConfirmationThankyouMsgComponent } from './atg-order-confirmation-thankyou-msg/atg-order-confirmation-thankyou-msg.component';
import { CardModule } from '@spartacus/storefront';


@NgModule({
  declarations: [AtgOrderConfirmationThankyouMsgComponent, AtgOrderConfirmationOverviewComponent],
  imports: [
    CommonModule,
    I18nModule,
    CardModule,
  ],
    providers: [
      provideConfig({
        cmsComponents: {
          OrderConfirmationOverviewComponent: {
            component: () => import('./atg-order-confirmation-overview/atg-order-confirmation-overview.component').then((c) => c.AtgOrderConfirmationOverviewComponent),
      
          },
          OrderConfirmationThankMessageComponent: {
            component: () => import('./atg-order-confirmation-thankyou-msg/atg-order-confirmation-thankyou-msg.component').then((c) => c.AtgOrderConfirmationThankyouMsgComponent),
         
          },
        },
      } as CmsConfig),
    ],
    exports: [AtgOrderConfirmationThankyouMsgComponent, AtgOrderConfirmationOverviewComponent],

})
export class AtgOderConfirmationModule { }
